import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const FavoritesContext = createContext();

const STORAGE_KEY = 'openps_favorites';

export const FavoritesProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const toggleFavorite = useCallback((game) => {
    setItems(prev => {
      const id = game.id || game.sony_id;
      const exists = prev.find(i => (i.id || i.sony_id) === id);
      if (exists) return prev.filter(i => (i.id || i.sony_id) !== id);
      return [...prev, game];
    });
  }, []);

  const isFavorite = useCallback((gameId) => {
    return items.some(i => (i.id || i.sony_id) === gameId);
  }, [items]);

  return (
    <FavoritesContext.Provider value={{ items, toggleFavorite, isFavorite, count: items.length }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
